import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import AppRoutes from './routes/AppRoutes';
import { AuthProvider } from './auth/AuthContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  </React.StrictMode>
);